import React, {Component} from "react";
import { withNamespaces } from "react-i18next";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {exhibitionMapActions} from "../../../actions/exhibition-map.actions";
import {Button, ButtonGroup, Card, Spinner} from "react-bootstrap";
import {modalActions} from "../../../actions/modal.actions";
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css'
import ExhibitionMapConfigForm from "./_forms/ExhibitionMapConfigForm";

class ExhibitionMapConfigPage extends Component {

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(exhibitionMapActions.getRooms());
    }

    onClickCreateModal = (e) => {
        e.preventDefault();
        const { t, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('add_exhibition-map-floor'),
            component: <ExhibitionMapConfigForm submitForm={this.handleSubmitAddMapConfig} />,
        };

        dispatch(modalActions.showModal({
            modalProps: modalProps,
            modalType: 'formModal'
        }));
    };

    onClickEditModel = (e, model) => {
        e.preventDefault();
        const { t, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('edit_exhibition-map-floor'),
            component: <ExhibitionMapConfigForm data={model} submitForm={this.handleSubmitEditMapConfig}/>
        };

        dispatch(modalActions.showModal({
            modalProps: modalProps,
            modalType: 'formModal'
        }));
    };

    onClickRemove = (e, model) => {
        e.preventDefault();
        const { t, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${model.label} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            confirmAction: () => {
                dispatch(exhibitionMapActions.deleteMapConfig(model.id))
            },
        };

        dispatch(modalActions.showModal({
            modalProps: modalProps,
            modalType: 'confirm'
        }));
    };

    handleSubmitAddMapConfig = (model) => {
        const { dispatch } = this.props;
        dispatch(exhibitionMapActions.createMapConfig(model));
    };

    handleSubmitEditMapConfig = (model) => {
        const { dispatch } = this.props;
        dispatch(exhibitionMapActions.editMapConfig(model));
    };


    render() {
        const { t, roomsList } = this.props;

        const breadcrumb = [
            { value: 'exhibition-map', path: '/panel/exhibition-map' },
            { value: 'config', path: '#'}
        ];

        const bodyResult = (
            roomsList ?
                roomsList.length === 0 ? (

                    <h4 className="text-center p-4">
                        {t("exhibition-map-is-not-define")}
                    </h4>

                ) : (
                    roomsList?.map((item) => {
                        return (
                            <div key={item.id} className="col-xl-4 col-md-6 col-sm-12">
                                <Card>

                                    <Zoom>
                                        <img className="card-img-top custom-image-card" alt={item.label} src={item.imageSrc} />
                                    </Zoom>

                                    <Card.Body>
                                        <Card.Title>
                                            <p className="m-0 p-0"><small>{t('name-rooms')}</small></p>
                                            {item.label}
                                        </Card.Title>

                                        <ButtonGroup className="float-right">
                                            <Button variant="primary" size={"sm"} onClick={(e) => this.onClickEditModel(e, item)}>
                                                {t('edit')} &nbsp; <i className="fas fa-edit"/>
                                            </Button>
                                            <Button variant="danger" size={"sm"} onClick={(e) => this.onClickRemove(e, item)}>
                                                {t('delete-btn')} &nbsp; <i className="fas fa-trash"/>
                                            </Button>
                                        </ButtonGroup>

                                    </Card.Body>
                                </Card>
                            </div>
                        )
                    })
                ) : (
                    <React.Fragment>
                        <Spinner animation={"border"} />
                        <p>Loading ...</p>
                    </React.Fragment>
                )
        );

        return(
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <div className="card">
                    <div className="card-header">
                        <div className="row">
                            <h4 className="col-md-6">{t('exhibition-map-config')}</h4>
                            <div className="col-md-6">
                                <div className="button-group float-right">
                                    <Button variant={"success"} onClick={this.onClickCreateModal}>
                                        <i className="fas fa-plus"> </i> &nbsp; { t('create') }
                                    </Button>
                                    &nbsp;
                                    <Link to={"/panel/exhibition-map"} className="btn btn-secondary" >
                                        <i className="fas fa-undo"> </i>
                                        <span> {t('back-to-list')} </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            { bodyResult }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    const { roomsList } = state.exhibitionMapReducer;
    return {
        roomsList
    }
};
export default withNamespaces()(connect(mapStateToProps)(ExhibitionMapConfigPage));
